import { IIconProps } from './add'

export const IcoRealtyMenu = ({style={}, cy}: IIconProps) => {
  return (
    <svg className='icon-realty-menu' viewBox="0 0 26 24" style={style} data-cy={`RealtyMenuIcon${cy}`}>
    <g id="Group_859" data-name="Group 859" transform="translate(-1676 -284)">
      <path id="Path_376" data-name="Path 376" d="M0,0H24V24H0Z" transform="translate(1676 284)" fill="none"/>
      <path id="Path_418" data-name="Path 418" d="M0,21V10L7.5,5,15,10V21H10V14H5v7H0M24,2V21H17V8.93l-1-.66V6H14v.93L10,4.27V2H24M21,14H19v2h2V14m0-4H19v2h2V10m0-4H19V8h2Z" transform="translate(1678 285)" fill="currentColor"/>
    </g>
    </svg>
  )
}